import { useState } from 'react';

export interface UseAddCardButtonInterface {
  isAddCardButtonDisabled: boolean;
  setIsAddCardButtonDisabled: React.Dispatch<React.SetStateAction<boolean>>;
}

export const useAddCardButton = (initialDisabled = false): UseAddCardButtonInterface => {
  const [isAddCardButtonDisabled, setIsAddCardButtonDisabled] = useState(initialDisabled);

  return {
    isAddCardButtonDisabled,
    setIsAddCardButtonDisabled,
  };
};
